import { Component, OnInit, Input, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';
import { URLSearchParams } from '@angular/http';

import {FileUpload, FileUploadModule} from 'primeng/primeng';

import { compareElements } from 'app/shared/validators/generic-validators';
import { ConstantsService } from 'app/services/constants-service';
import { CookieService } from 'app/services/cookie.service';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { unsavedFormCheck } from 'app/shared/validators/generic-validators';

import { TaskDefinition } from 'app/shared/models/task-definition.model';

import { ProcessService } from './../process.service';

@Component({
  templateUrl: './process-upload.component.html',
  providers: [ProcessService]
})

/**
 * Dialog component to upload process and tasks through files.
 */
export class ProcessUploadComponent {
  processUploadForm: FormGroup;
  flagProcessFileUpload: boolean = false;
  uploadPorcessStart: boolean = false;
  fileUploadEvent: any;

  constructor(private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<any>,
    private processService: ProcessService,
    private snackBarService: SnackBarService,
    private trackingService: TrackingService,
    private cookieService: CookieService) {
  }

  processFileUploadChange(event) {
    this.fileUploadEvent = event;
    this.flagProcessFileUpload = true;
  }

  /**
   * This is not the ideal way to upload the file. This code is written to support the jersey 1.X version on backend.
   * Because when we use the http module of angular 2 then it doesn't send the boundary content type in request and it
   * results into 500 and 400 request on backend.
   */
  processFileUploader() {
    this.uploadPorcessStart = true;
    let processFileUploadList: FileList = this.fileUploadEvent.target.files;
    if (processFileUploadList.length > 0) {

      let xhr: XMLHttpRequest = new XMLHttpRequest();
      const processFileUploadURL = ConstantsService.APP_BE_URL + '/rest'+ ConstantsService.UPLOAD_PROCESS_FILE_URL;

      let processUploadfile: File = processFileUploadList[0];
      let processUploadFormData: FormData = new FormData();
      processUploadFormData.append('file', processUploadfile, processUploadfile.name);

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            this.callSnackBarService(JSON.parse(xhr.response));
          } else {
            this.callSnackBarService(JSON.parse(xhr.response));
          }
          this.uploadPorcessStart = false;
          this.dialogRef.close('imported');
        }
        this.flagProcessFileUpload = false;
      };

      xhr.open('POST', processFileUploadURL, true);
      xhr.setRequestHeader('Authorization', 'Bearer ' + this.cookieService.get(ConstantsService.COOKIE_ACCESS_TOKEN));
      xhr.setRequestHeader('app-type', 'TRUST');
      xhr.send(processUploadFormData);
    }
  }

  private callSnackBarService(response: any) {
    this.snackBarService
      .showStatus(response, MessageService.PROCESS_FILE_UPLOAD_SUCCESS, MessageService.PROCESS_FILE_UPLOAD_FAILURE);
  }

  @HostListener('keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    unsavedFormCheck(event, this.dialogRef, this.processUploadForm);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/processes/processupload/process-upload.component.ts